import { Link } from "react-router-dom";
import { useCart } from "@shopify/hydrogen-react";
import { Trash2 } from "lucide-react";

const Cart = () => {
  const { lines, totalQuantity, cost, checkoutUrl, linesRemove } = useCart();

  if (!totalQuantity || totalQuantity === 0) {
    return (
      <div className="max-w-3xl mx-auto py-16 px-6 text-center">
        <h1 className="text-3xl font-bold mb-6" style={{ fontFamily: "var(--font-heading)" }}>
          Your Cart
        </h1>
        <p className="text-gray-600 mb-8">Your cart is empty.</p>
        <Link
          to="/studio"
          className="inline-block px-6 py-3 rounded-lg text-white"
          style={{ backgroundColor: "var(--sage-400)" }}
        >
          Continue Shopping
        </Link>
      </div>
    );
  }

  const handleCheckout = () => {
    if (checkoutUrl) {
      window.location.href = checkoutUrl;
    }
  };

  return (
    <div className="max-w-3xl mx-auto py-16 px-6">
      <h1 className="text-3xl font-bold mb-8" style={{ fontFamily: "var(--font-heading)" }}>
        Your Cart ({totalQuantity} {totalQuantity === 1 ? "item" : "items"})
      </h1>

      <div className="space-y-6">
        {(lines ?? []).map((line) => {
          if (!line?.id) return null;
          const title = line.merchandise?.title ?? "Custom Map";
          const price = line.cost?.totalAmount?.amount;
          const address = line.attributes?.find(a => a.key === "Address")?.value;

          return (
            <div
              key={line.id}
              className="flex items-center justify-between border-b pb-6"
              style={{ borderColor: "var(--brand-border)" }}
            >
              <div className="flex-1">
                <h3 className="font-medium">{title}</h3>
                {address && (
                  <p className="text-sm text-gray-500 mt-1">{address}</p>
                )}
                <p className="text-sm mt-1">Qty: {line.quantity}</p>
              </div>
              <div className="flex items-center gap-4">
                {price && (
                  <span className="font-medium">
                    ${parseFloat(price).toFixed(2)}
                  </span>
                )}
                <button
                  onClick={() => linesRemove([line.id!])}
                  className="p-1 text-gray-400 hover:text-red-500 transition-colors"
                  aria-label="Remove item"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-8 border-t pt-6" style={{ borderColor: "var(--brand-border)" }}>
        <div className="flex justify-between text-lg font-bold mb-6">
          <span>Total</span>
          <span>${parseFloat(cost?.totalAmount?.amount ?? "0").toFixed(2)}</span>
        </div>

        <button
          onClick={handleCheckout}
          className="w-full py-4 rounded-lg text-white text-lg font-semibold"
          style={{ backgroundColor: "var(--sage-400)" }}
        >
          Proceed to Checkout
        </button>

        <Link
          to="/studio"
          className="block text-center mt-4 text-sm underline"
          style={{ color: "var(--brand-muted)" }}
        >
          Continue Shopping
        </Link>
      </div>
    </div>
  );
};

export default Cart;
